import React from "react";

import type LabelProps from "./LabelProps";
import NavItemLabel from "./NavItemLabel";

function ChapterLabel(props: LabelProps & {link?: string}) {
	return (
		<NavItemLabel
			number={props.index}
			text={props.text}
			variant="body1"
			link={props.link}
			onClick={props.onClick}
			slotProps={{number: {sx: {mr: 2}}}}
		/>
	);
}

export default ChapterLabel;
